export function setWindowsVariable(variable, key) {
  window[variable] = key;
}
